/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Best_MatchInputs */

const en_palette_best_match = /** @type {(inputs: Palette_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best match`)
};

/**
* | output |
* | --- |
* | "Best match" |
*
* @param {Palette_Best_MatchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_best_match = /** @type {((inputs?: Palette_Best_MatchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Best_MatchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_best_match(inputs)
});